// extracted by mini-css-extract-plugin
export default {"layoutContainer":"SharedLayout_layoutContainer__mGE2d"};